import {ActionsPayload, NodePayload} from "./index.d";
import {apiClient} from "@/utils/apiClient";

export const createFlow = async (payload: NodePayload): Promise<any> => {
  const endpoint = "/nodes";
  return apiClient(endpoint, {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const getFlow = async (payload: NodePayload): Promise<any> => {
  const endpoint = `/nodes/${payload.model_id}`;
  const method = "GET";

  return apiClient(endpoint, {
    method: method,
  });
};

export const editFlow = async (payload: NodePayload): Promise<any> => {
  const endpoint = `/nodes/${payload.model_id || payload.node_id}`;
  const method = "PUT";

  return apiClient(endpoint, {
    method: method,
    body: JSON.stringify(payload),
  });
};

// Assistant actions
export const getNodeActions = async (payload: ActionsPayload): Promise<any> => {
  const endpoint = `/nodes/${payload.model_id}/actions?action_type=${payload.action_type}&node_id=${payload.model_id}`;
  const method = "GET";

  return apiClient(endpoint, {
    method: method,
  });
};
